export default "__VITE_ASSET__BBnDEYE8__"